import ingredientAmounts from '../../components/blog/ingredient-amounts';

ingredientAmounts();
